import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 0.1rem solid ${COLORS.gray600};
    box-sizing: border-box;
    border-radius: 5px;
    padding: 3.4rem 3.2rem 3.2rem;
    background-color: ${COLORS.white};

    &:hover {
        background-color: ${COLORS.gray50};
    }

    &:not(:last-child) {
        margin-bottom: 4rem;
    }

    a {
        text-decoration: none;
    }

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem;
    `}
`;

export const Header = styled.div`
    margin-bottom: 1.6rem;
    display: grid;
    grid-template-areas: 'id title status';
    grid-template-columns: min-content auto 1fr;
    align-items: center;
    grid-column-gap: 1.5rem;

    ${respondDown(Breakpoints.lg)`
        grid-template-areas: 'id status' 'title title';
        grid-template-columns: min-content 1fr;
        grid-row-gap: 1.5rem;
    `}
`;

export const Text = styled.div`
    display: -webkit-box;
    max-height: 6rem;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 2.4rem;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};

    ${respondDown(Breakpoints.md)`
        -webkit-line-clamp: 5;
        max-height: 10rem;
    `}
`;

export const SummaryBlock = styled.div`
    display: flex;
    justify-content: space-between;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
    `}
`;

export const SummaryColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 33%;

    ${respondDown(Breakpoints.md)`
         max-width: unset;
         margin-bottom: 1.6rem;
    `}
`;

export const SummaryTitle = styled.div`
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 1.6rem;
    color: ${COLORS.textGray};
    margin-bottom: 0.8rem;
`;

export const SummaryValue = styled.div`
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLORS.textTertiary};
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
`;
